import { ReactNode } from "react";

interface IContainerProps {
  children: ReactNode;
}

const Container = ({ children }: IContainerProps) => (
  <div
    css={{
      maxWidth: 860,
      width: "100%",
      margin: "0 auto",
      padding: "0 10px"
    }}
  >
    {children}
  </div>
);

export default Container;
